angular.module('aprima-legacy-common').
    factory('ListNavigationService', ['$log', '$filter', 'Bridge',
        function ($log, $filter, Bridge) {
            'use strict';

            var cachedEnumerators = [];
            var activeItems = [];

            var registerActiveItemForList = function (listType, itemId, settings, $scope) {
                var enumerator = this.getEnumerator(listType);

                if(enumerator){
                    enumerator.setActiveItemById(itemId);
                    this.hydrateListNavigationProperties(listType, settings);
                    this.setAsBridgeHandler(listType, $scope);
                }

                activeItems[listType] = itemId;
            };

            var deregisterActiveItemForList = function (listType, itemId) {
                if (activeItems[listType] && activeItems[listType] === itemId) {
                    activeItems[listType] = null;
                }
            };

            //orderPredicate can be prefixed with a '+' or '-' to change the direction of the sort. '+' is ascending and the default.
            //'-' is descending
            var buildAndCacheEnumerator = function (enumeratorName, list, orderPredicate, transitionFunction) {
                var filter = $filter('orderBy');

                var enumerator = this.buildEnumerator(filter(list, orderPredicate), transitionFunction);

                cachedEnumerators[enumeratorName] = enumerator;

                if (activeItems[enumeratorName]) {
                    enumerator.setActiveItemById(activeItems[enumeratorName]);
                }

                return enumerator;
            };

            var setActiveItemByIdForEnumerator = function (enumeratorName, id) {
                var enumerator = cachedEnumerators[enumeratorName];
                if (enumerator) {
                    enumerator.setActiveItemById(id);
                }
            };

            var getEnumerator = function (enumeratorName) {
                return cachedEnumerators[enumeratorName];
            };

            var hydrateListNavigationProperties = function (enumeratorName, settings) {
                var enumerator = cachedEnumerators[enumeratorName];

                if (enumerator) {
                    angular.forEach(settings.phone.modes, function (value) {
                        angular.forEach(value.headers, function (headerValue) {
                            if (headerValue.requiresNavSettings) {
                                headerValue.listNavigationProperties = enumerator.getNavStatus();
                            }
                        });
                    });

                    angular.forEach(settings.tablet.modes, function (value) {
                        angular.forEach(value.headers, function (headerValue) {
                            if (headerValue.requiresNavSettings) {
                                headerValue.listNavigationProperties = enumerator.getNavStatus();
                            }
                        });
                    });
                }
            };

            var setAsBridgeHandler = function (enumeratorName, $scope) {
                var enumerator = cachedEnumerators[enumeratorName];

                if (enumerator) {
                    Bridge.on('navigate-item', $scope, function (data) {
                        switch (data.navigationType) {
                            case 'next':
                                enumerator.moveToNextItem();
                                break;
                            case 'previous':
                                enumerator.moveToPreviousItem();
                                break;
                            default:
                                break;
                        }
                    });
                }
            };

            var buildEnumerator = function (list, callbackFunction) {
                $log.info('enumerator built');

                var currentIndex = -1;

                var transitionFunction = function (item) {
                    currentIndex = list.indexOf(item);

                    if (callbackFunction) {
                        callbackFunction(item);
                    }
                };

                var next = function () {
                    var lookupIndex;

                    if (currentIndex !== -1) {
                        if (currentIndex === (list.length - 1)) {
                            return null;
                        }
                        else {
                            lookupIndex = currentIndex + 1;
                        }
                    }
                    else {
                        if (list.length === 0) {
                            return null;
                        }
                        lookupIndex = 0;
                    }

                    return list[lookupIndex];
                };

                var previous = function () {
                    var lookupIndex;

                    if (currentIndex !== -1) {
                        if (currentIndex === 0) {
                            return null;
                        }
                        else {
                            lookupIndex = currentIndex - 1;
                        }
                    }
                    else {
                        if (list.length === 0) {
                            return null;
                        }

                        lookupIndex = list.length - 1;
                    }

                    return list[lookupIndex];
                };

                var first = function () {
                    if (list.length === 0) {
                        return null;
                    }

                    return list[0];
                };

                var last = function () {
                    if (list.length === 0) {
                        return null;
                    }

                    return list[list.length - 1];
                };

                var moveToNextItem = function () {
                    var next = this.next();

                    if (next) {
                        transitionFunction(next);
                    }
                };

                var moveToPreviousItem = function () {
                    var previous = this.previous();

                    if (previous) {
                        transitionFunction(previous);
                    }
                };

                var moveToFirstItem = function () {
                    transitionFunction(this.first());
                };

                var moveToLastItem = function () {
                    transitionFunction(this.last());
                };

                var moveToItem = function (item) {
                    var indexOf = list.indexOf(item);

                    if (indexOf >= 0) {
                        currentIndex = indexOf;
                        transitionFunction(item);
                    }
                    else {
                        throw new Exception('Cannot move to item as it does not exist in the list.');
                    }
                };

                var setActiveItemById = function (id) {
                    for (var i = 0; i <= list.length - 1; i++) {
                        if (list[i].Id === id) {
                            currentIndex = i;
                            break;
                        }
                    }
                };

                var canGoNext = function () {
                    return (currentIndex !== -1) && (currentIndex !== (list.length - 1));
                };

                var canGoPrevious = function () {
                    return (currentIndex !== -1) && (currentIndex !== 0);
                };

                var getNavStatus = function () {
                    return {
                        canGoForward: this.canGoNext(),
                        canGoBack: this.canGoPrevious()
                    };
                };

                var currentItem = function () {
                    if (currentIndex !== -1) {
                        return list[currentIndex];
                    }
                    else {
                        return null;
                    }
                };

                var toArray = function() {
                    var oldIndex = currentIndex;
                    var arr = [];
                    currentIndex = 0;

                    if(currentItem()) {
                        arr.push(currentItem());
                    }

                    while(canGoNext()){
                        arr.push(next());
                        currentIndex++;
                    }

                    currentIndex = oldIndex;
                    return arr;
                };

                return {
                    next: next,
                    previous: previous,
                    first: first,
                    last: last,
                    moveToNextItem: moveToNextItem,
                    moveToPreviousItem: moveToPreviousItem,
                    moveToFirstItem: moveToFirstItem,
                    moveToLastItem: moveToLastItem,
                    moveToItem: moveToItem,
                    canGoNext: canGoNext,
                    canGoPrevious: canGoPrevious,
                    getNavStatus: getNavStatus,
                    setActiveItemById: setActiveItemById,
                    currentItem: currentItem,
                    toArray: toArray
                };
            };

            return {
                buildAndCacheEnumerator: buildAndCacheEnumerator,
                getEnumerator: getEnumerator,
                buildEnumerator: buildEnumerator,
                hydrateListNavigationProperties: hydrateListNavigationProperties,
                setAsBridgeHandler: setAsBridgeHandler,
                registerActiveItemForList: registerActiveItemForList,
                deregisterActiveItemForList: deregisterActiveItemForList,
                setActiveItemByIdForEnumerator: setActiveItemByIdForEnumerator
            };
        }]);